import React from "react";
import CustomMenu from "./common/CustomMenu";
import { LuChevronDown } from "react-icons/lu";
import CustomPaperBox from "./common/CustomPaperBox";

export const CustomDropDownMenuLabel = ({ label, icon }) => (
  <CustomPaperBox className="flex gap-2 items-center py-[0.25rem!important] px-[0.5rem!important] h-10 w-full">
    {label && <span>{label}</span>}
    {icon || <LuChevronDown size={16} className="ml-auto"/>}
  </CustomPaperBox>
);

const CustomDropdownMenu = ({
  list = [],
  label,
  icon = null,
  position = "default",
  labelComp = null,
  width = null,
  height = '15rem',
  disableOpen = false,
  onBlockedClick = () => {},
}) => {
  return (
    <div className="relative">
      <CustomMenu
        position={position}
        label={
          <div onClick={(e) => {
            if (disableOpen) {
              e.stopPropagation();
              onBlockedClick(); // trigger toast
            }
          }}><CustomDropDownMenuLabel label={labelComp || label} icon={icon} /></div>
          
        }
        contentStyle={{width:'100%',height: height}}
        wrapperStyle={{minWidth: '10rem'}}
        disabled={disableOpen}
      >
        {({ handleToggle }) => (
          <div className="flex flex-col ">
            {list.map((item) => (
              <div
                className="flex gap-3 item-center py-2 px-4 cursor-pointer hover:bg-slate-100"
                onClick={() => {
                  item?.onClick?.();

                  handleToggle();
                }}
              >
                {item.icon}
                <span className="text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </CustomMenu>
    </div>
  );
  return (
    <div className="relative">
      <CustomMenu>
        {({ handleToggle }) => (
          <div className="flex flex-col ">
            {list.map((item) => (
              <div
                className="flex gap-3 item-center py-2 px-4 cursor-pointer hover:bg-slate-100"
                onClick={() => {
                  item?.onClick?.();

                  handleToggle();
                }}
              >
                {item.icon}
                <span className="font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </CustomMenu>
    </div>
  );
};

export default CustomDropdownMenu;
